import React from 'react';
import i18next from 'i18next';
import PropTypes from 'prop-types';

// Styles
import './assets/stylesheets/index.scss';


// Components
import LocationContextProvider from './Components/LocationContext/LocationContext';
import LocationIndex from './Components/LocationIndex/LocationIndex';

function App({ locale = 'de' }) {

    React.useEffect(() => {
        if (locale) {
            i18next.changeLanguage(locale).then();
        }
    }, [locale]);

    return (
        <LocationContextProvider locale={locale}>
            <LocationIndex locale={locale} />
        </LocationContextProvider>
    );
}

App.propTypes = {
    locale: PropTypes.string,
};

export default App;
